export const ERROR_CODES = {
    CSRF_TOKEN_GENERATION_ERROR: 'KN200CTGE'
};
